import classNames from 'classnames';
import { FC } from 'react';

import Input from '../Input/Input';
import classes from './NumberSelect.module.scss';

export interface NumberSelectProps {
  value: number;
  onChange?: (v: number) => void;
  minValue?: number;
  maxValue?: number;
  className?: string;
}

const NumberSelect: FC<NumberSelectProps> = ({
  value,
  onChange,
  minValue = 0,
  maxValue = 100,
  className,
}) => {
  return (
    <Input
      className={classNames(classes.Container, className)}
      value={isNaN(value) ? '' : value}
      type="number"
      InputProps={{ inputProps: { min: minValue, max: maxValue } }}
      onChange={(e) => onChange?.(parseInt(e.target.value))}
    />
  );
};

export default NumberSelect;
